import request from '../utils/request'

export default {
  // 获取所有
  findAll(params) {
    return request.get('/api/order', { params })
  },

  // 根据订单号查询
  getByOrderNo(orderNo) {
    return request.get(`/api/order/no/${orderNo}`)
  },

  // 根据订单号查询订单详细信息
  getDetailByOrderNo(orderNo) {
    return request.get(`/api/order/detail/${orderNo}`)
  },

  // 申请退款
  refund(params) {
    return request.post('/api/order/refund', params)
  },
  
  // 导出支付订单
  exportPayOrders(params) {
    return request({
      url: '/api/order/exportPayOrders',
      method: 'get',
      params,
      responseType: 'blob' // 导出文件需指定响应类型为blob
    });
  },
}